import { HeaderMinimal } from '@xing-com/crate-layout-header-minimal';
import { useLoginState } from '@xing-com/hub';
import { SkipNavigation } from '@xing-com/platform-layout-skip-navigation';

import { HeaderNavItemsLoggedIn } from './header-nav-items-logged-in';
import { HeaderNavItemsLoggedOut } from './header-nav-items-logged-out';
import { StyledOuterActionsContainer } from './header.styles';

export type HeaderProps = {
  className?: string;
  loginLink?: string;
};

export const Header: React.FC<HeaderProps> = ({ className, loginLink }) => {
  const isLoggedOut = useLoginState() === 'LOGGED_OUT';

  return (
    <HeaderMinimal
      showOnSmallerScreens={isLoggedOut}
      className={className}
      preChildren={<SkipNavigation />}
    >
      <StyledOuterActionsContainer
        aria-label="header-navigation"
        data-testid="header-navigation"
        as="nav"
      >
        {isLoggedOut ? (
          <HeaderNavItemsLoggedOut loginLink={loginLink} />
        ) : (
          <HeaderNavItemsLoggedIn />
        )}
      </StyledOuterActionsContainer>
    </HeaderMinimal>
  );
};
